import Layout from "components/ui/Layout";
import { usePackages } from "features/package/hooks/usePackages";
import { usePrefetchPackages } from "features/package/hooks/usePrefetchPackages";
import { useTogglePackageStatus } from "features/package/hooks/useTogglePackageStatus";
import { useURLSync } from "features/package/hooks/useURLSync";
import { ViewPackageModal } from "features/package/components/ViewPackageModal";
import { EditPackageModal } from "features/package/components/EditPackageModal";
import { DeleteConfirmModal } from "features/package/components/DeleteConfirmModal";
// import { useAdmins } from 'features/admin/hooks/useAdmins';
import { useUserProfile } from 'features/auth/hooks/useUserProfile';

import { packageServices } from 'features/package/services/package.service';


import {
  ChevronLeft,
  ChevronRight,
  Download,
  Edit,
  Eye,
  Plus,
  Search,
  Trash2,
  X,
  Package as PackageIcon,
} from "lucide-react";
import { useEffect, useState } from "react";
import { formatDateTime } from "utils/dateFormatter";
import { useNavigate } from "react-router-dom";

const PackageManagement = () => {
  const navigate = useNavigate();

  const [filters, setFilters] = useURLSync({
    page: "1",
    limit: "10",
    sellerId: "",
    isActive: "all",
    isPopular: "all",
    isFeatured: "all",
    search: "",
    sortBy: "createdAt",
    sortOrder: "desc",
  });

  const [searchInput, setSearchInput] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);

    const { data: profileData } = useUserProfile();
    const user = profileData?.data;

  const packageFilters = {
  ...filters,
  ...(user?.role?.name === "travel_manager" && {
    type: "tour",
  }),
};

  const { data, isPending, isError, error } = usePackages(packageFilters);
  const { mutate: toggleStatus } = useTogglePackageStatus();
  const { prefetchNextPage, prefetchPrevPage } = usePrefetchPackages();

  

// console.log('Current Role:', user?.role?.name);

const restrictedRoles = [
  "delivery_manager",
  "category_manager",
  "operations_manager",
  // 'travel_manager',
  "finance_manager",
];

const showPermissionError = restrictedRoles.includes(
  user?.role?.name
);

  useEffect(() => {
    if (data?.pagination) {
      const { currentPage, totalPages } = data.pagination;
      prefetchNextPage(filters, totalPages);
      if (currentPage > 1) {
        prefetchPrevPage(filters);
      }
    }
  }, [data, filters]);

  // console.log("pakage listing::::::::>>>>>>>>>>>>>", data);

  const updateFilter = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      page: key === "page" ? value : "1",
    }));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchInput !== filters.search) {
        updateFilter("search", searchInput);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => {
    setSearchInput(filters.search);
  }, [filters.search]);

  const handleSort = (column) => {
    const newOrder =
      filters.sortBy === column && filters.sortOrder === "asc" ? "desc" : "asc";
    setFilters((prev) => ({
      ...prev,
      sortBy: column,
      sortOrder: newOrder,
    }));
  };

const handleExport = async () => {
  try {
    const response =
      await packageServices.exportPackages({
        sellerId:
          filters.sellerId,

        isActive:
          filters.isActive,

        isPopular:
          filters.isPopular,

        isFeatured:
          filters.isFeatured,

        search:
          filters.search,

        sortBy:
          filters.sortBy,

        sortOrder:
          filters.sortOrder,

        type:
          user?.role?.name ===
          'travel_manager'
            ? 'tour'
            : undefined,
      });

    const blob = new Blob(
      [response.data],
      {
        type: 'text/csv',
      }
    );

    const url =
      window.URL.createObjectURL(
        blob
      );

    const link =
      document.createElement('a');

    link.href = url;

    link.download = `packages-${Date.now()}.csv`;

    document.body.appendChild(
      link
    );

    link.click();

    document.body.removeChild(
      link
    );

    window.URL.revokeObjectURL(
      url
    );
  } catch (error) {
    console.error(
      'Failed to export packages:',
      error
    );
  }
};

  const SortIcon = ({ column }) => {
    if (filters.sortBy !== column)
      return <span className="text-muted-foreground">↕</span>;
    return filters.sortOrder === "asc" ? <span>↑</span> : <span>↓</span>;
  };

  const handleEditClick = (pkg) => {
    setIsEditModalOpen(true);
    setSelectedPackage(pkg);
  };

  const handleDeleteClick = (pkg) => {
    setSelectedPackage(pkg);
    setIsDeleteModalOpen(true);
  };

  const handleViewClick = (pkg) => {
    setSelectedPackage(pkg);
    setIsViewModalOpen(true);
  };

  const handleToggleStatus = (packageId, currentStatus) => {
    toggleStatus({ packageId, isActive: !currentStatus });
  };

  return (
    <Layout>
      <div className="min-h-screen bg-background text-foreground p-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 space-y-4 sm:space-y-0">
            <div>
              <h3 className="text-lg font-semibold mb-1">Package Management</h3>
              <p className="text-sm text-muted-foreground">
                Manage service packages and bundle offers
              </p>
            </div>

            <div className="flex space-x-3">
              {/* <button
                onClick={() => setIsAddModalOpen(true)}
                className='flex items-center space-x-2 px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors'
              >
                <Plus size={16} />
                <span>Add Package</span>
              </button> */}

            {!showPermissionError && (
  <button
    onClick={handleExport}
    className='flex items-center space-x-2 px-4 py-2 text-sm border border-border rounded-md bg-card text-card-foreground hover:bg-accent transition-colors'
  >
    <Download size={16} />
    <span>Export</span>
  </button>
)}
            </div>
          </div>

          {/* Filters */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 mb-6">
            {/* Search */}
            <div className="relative lg:col-span-2">
              <Search
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
                size={16}
              />
              <input
                type="text"
                placeholder="Search by package name..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="w-full pl-10 pr-10 py-2 text-sm"
              />
              {searchInput && (
                <button
                  onClick={() => setSearchInput("")}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground hover:text-foreground"
                >
                  <X size={16} />
                </button>
              )}
            </div>

            {/* Active Status Filter */}
            <select
              value={filters.isActive}
              onChange={(e) => updateFilter("isActive", e.target.value)}
              className="px-3 py-2 text-sm"
            >
              <option value="all">All Status</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>

            {/* Popular Filter */}
            {/* <select
              value={filters.isPopular}
              onChange={(e) => updateFilter('isPopular', e.target.value)}
              className='px-3 py-2 text-sm'
            >
              <option value='all'>All Popular</option>
              <option value='true'>Popular</option>
              <option value='false'>Not Popular</option>
            </select> */}

            {/* Items per page */}
            <select
              value={filters.limit}
              onChange={(e) => updateFilter("limit", e.target.value)}
              className="px-3 py-2 text-sm"
            >
              <option value="5">5 per page</option>
              <option value="10">10 per page</option>
              <option value="20">20 per page</option>
              <option value="50">50 per page</option>
            </select>
          </div>

          {/* Table */}
          <div className="bg-card border border-border rounded-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-muted border-b border-border">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase">
                      Image
                    </th>
                    <th
                      className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase cursor-pointer hover:text-foreground"
                      onClick={() => handleSort("name")}
                    >
                      <div className="flex items-center space-x-1">
                        <span>Package Name</span>
                        <SortIcon column="name" />
                      </div>
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase">
                      Seller
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase">
                      Services/Tours
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase">
                      Pricing
                    </th>
                    {/* <th className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase'>
                      Discount
                    </th> */}
                    <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase">
                      Duration
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase">
                      Status
                    </th>
                    {/* <th className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase'>
                      Popular
                    </th>
                    <th className='px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase'>
                      Bookings
                    </th> */}
                    <th
                      className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase cursor-pointer hover:text-foreground"
                      onClick={() => handleSort("createdAt")}
                    >
                      <div className="flex items-center space-x-1">
                        <span>Created</span>
                        <SortIcon column="createdAt" />
                      </div>
                    </th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-muted-foreground uppercase">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border">
                  {showPermissionError ? (
                    <tr>
                      <td
                        colSpan={12}
                        className="px-4 py-8 text-center text-destructive"
                      >
                        Error loading packages: You do not have permission to
                        perform this action!
                      </td>
                    </tr>
                  ) : isPending ? (
                    <tr>
                      <td
                        colSpan={12}
                        className="px-4 py-8 text-center text-muted-foreground"
                      >
                        Loading packages...
                      </td>
                    </tr>
                  ) : isError ? (
                    <tr>
                      <td
                        colSpan={12}
                        className="px-4 py-8 text-center text-destructive"
                      >
                        Error loading packages:{" "}
                        {error?.message || "Something went wrong"}
                      </td>
                    </tr>
                  ) : data?.data?.length === 0 ? (
                    <tr>
                      <td
                        colSpan={12}
                        className="px-4 py-8 text-center text-muted-foreground"
                      >
                        No packages found
                      </td>
                    </tr>
                  ) : (
                    data?.data?.map((pkg) => (
                      <tr
                        key={pkg._id}
                        className="hover:bg-muted/50 transition-colors"
                      >
                        {/* Image Column */}
                        <td className="px-4 py-3">
                          {pkg.images && pkg.images.length > 0 ? (
                            <img
                              src={pkg.images[pkg.images.length - 1]}
                              alt={pkg.name}
                              className="w-12 h-12 rounded-lg object-cover border border-border"
                            />
                          ) : (
                            <div className="w-12 h-12 rounded-lg bg-muted flex items-center justify-center">
                              <PackageIcon
                                size={20}
                                className="text-muted-foreground"
                              />
                            </div>
                          )}
                        </td>

                        {/* Package Name Column */}
                        <td className="px-4 py-3 text-sm font-medium">
                          <div className="max-w-xs">
                            <div className="text-foreground truncate">
                              {pkg.name}
                            </div>
                            {pkg.slug && (
                              <div className="text-xs text-muted-foreground truncate">
                                {pkg.slug}
                              </div>
                            )}
                          </div>
                        </td>

                        {/* Seller Column */}
                        <td className="px-4 py-3 text-sm">
                          <div className="max-w-xs truncate">
                            {pkg.sellerId?.firstName || pkg.sellerId?.lastName
                              ? `${pkg.sellerId?.firstName || ""} ${pkg.sellerId?.lastName || ""}`.trim()
                              : pkg.sellerId?.phoneNumber || "N/A"}
                          </div>
                        </td>

                        {/* Services Column */}
                        <td className="px-4 py-3 text-sm">
                          <span
                            className="px-2 py-1 rounded-full text-xs font-medium  block
                                        leading-relaxed
                                        whitespace-normal "
                          >
                            {/* {pkg.serviceIds?.length || 0} services */}
                            {pkg?.serviceIds?.length > 0
                              ? pkg.serviceIds
                                  .map((service) => service.name)
                                  .join(", ")
                              : pkg?.tourIds
                                  ?.map((tour) => tour.title)
                                  .join(", ")}
                          </span>
                        </td>

                        {/* Pricing Column */}
                        <td className="px-4 py-3 text-sm">
                          <div>
                            <div className="font-medium text-foreground whitespace-nowrap">
                              {pkg.pricing?.currency || "INR"}{" "}
                              {pkg.pricing?.bookingPrice?.toFixed(2) || "0.00"}
                            </div>
                            {pkg.pricing?.accumulatedPrice >
                              pkg.pricing?.bookingPrice && (
                              <div className="text-xs text-muted-foreground line-through">
                                {pkg.pricing?.currency || "INR"}{" "}
                                {pkg.pricing?.accumulatedPrice?.toFixed(2)}
                              </div>
                            )}
                          </div>
                        </td>

                        {/* Discount Column */}
                        {/* <td className='px-4 py-3 text-sm'>
                          {pkg.pricing?.discountPercentage > 0 ? (
                            <span className='px-2 py-1 bg-green-500/10 text-green-600 dark:text-green-400 rounded-full text-xs font-medium whitespace-nowrap'>
                              {pkg.pricing?.discountPercentage}% OFF
                            </span>
                          ) : (
                            <span className='text-muted-foreground'>-</span>
                          )}
                        </td> */}

                        {/* Duration Column */}
                        <td className="px-4 py-3 text-sm text-muted-foreground">
                          {pkg.duration > 0
                            ? `${pkg.duration} ${pkg.durationType || "hours"}`
                            : "-"}
                        </td>

                        {/* Status Column - SWITCH */}
                        <td className="px-4 py-3 text-sm">
                          <label className="relative inline-flex items-center cursor-pointer group">
                            <input
                              type="checkbox"
                              checked={pkg.isActive}
                              onChange={() =>
                                handleToggleStatus(pkg._id, pkg.isActive)
                              }
                              className="sr-only peer"
                            />
                            <div className="w-11 h-6 bg-gray-200 dark:bg-gray-700 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600"></div>
                            <span className="ms-3 text-sm font-medium text-foreground group-hover:text-primary transition-colors">
                              {pkg.isActive ? "Active" : "Inactive"}
                            </span>
                          </label>
                        </td>

                        {/* Popular Column */}
                        {/* <td className='px-4 py-3 text-sm'>
                          <span
                            className={`px-2 py-1 text-xs font-medium rounded-full ${
                              pkg.isPopular
                                ? 'bg-orange-500/10 text-orange-600 dark:text-orange-400'
                                : 'bg-gray-500/10 text-gray-600 dark:text-gray-400'
                            }`}
                          >
                            {pkg.isPopular ? 'Popular' : 'Regular'}
                          </span>
                        </td> */}

                        {/* Bookings Column */}
                        {/* <td className='px-4 py-3 text-sm text-muted-foreground'>
                          {pkg.stats?.totalBookings || 0}
                        </td> */}

                        {/* Created Date Column */}
                        <td className="px-4 py-3 text-sm text-muted-foreground">
                          {formatDateTime(pkg.createdAt)}
                        </td>

                        {/* Actions Column */}
                        <td className="px-4 py-3 text-sm text-right">
                          <div className="flex items-center justify-end space-x-2">
                            <button
                              className="p-1 hover:bg-muted rounded transition-colors"
                              title="View Details"
                              onClick={() => handleViewClick(pkg)}
                            >
                              <Eye
                                size={16}
                                className="text-muted-foreground hover:text-foreground"
                              />
                            </button>
                            <button
                              className="p-1 hover:bg-muted rounded transition-colors"
                              title="Edit Package"
                              onClick={() => handleEditClick(pkg)}
                            >
                              <Edit
                                size={16}
                                className="text-muted-foreground hover:text-foreground"
                              />
                            </button>
                            <button
                              onClick={() => handleDeleteClick(pkg)}
                              className="p-1 hover:bg-muted rounded transition-colors"
                              title="Delete Package"
                            >
                              <Trash2
                                size={16}
                                className="text-muted-foreground hover:text-destructive"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {!showPermissionError && data?.pagination && (
              <div className="flex flex-col sm:flex-row items-center justify-between px-4 py-3 border-t border-border space-y-3 sm:space-y-0">
                <div className="text-sm text-muted-foreground">
                  Showing{" "}
                  {(data.pagination.currentPage - 1) *
                    data.pagination.itemsPerPage +
                    1}{" "}
                  to{" "}
                  {Math.min(
                    data.pagination.currentPage * data.pagination.itemsPerPage,
                    data.pagination.totalItems,
                  )}{" "}
                  of {data.pagination.totalItems} packages
                </div>

                <div className="flex items-center space-x-2">
                  <button
                    onClick={() =>
                      updateFilter(
                        "page",
                        String(data.pagination.currentPage - 1),
                      )
                    }
                    disabled={data.pagination.currentPage === 1}
                    className="p-2 border border-border rounded-md bg-card hover:bg-accent disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  >
                    <ChevronLeft size={16} />
                  </button>

                  <div className="flex items-center space-x-1">
                    {[...Array(data.pagination.totalPages)].map((_, idx) => {
                      const page = idx + 1;
                      const current = data.pagination.currentPage;

                      if (
                        page === 1 ||
                        page === data.pagination.totalPages ||
                        (page >= current - 1 && page <= current + 1)
                      ) {
                        return (
                          <button
                            key={page}
                            onClick={() => updateFilter("page", String(page))}
                            className={`min-w-[2rem] px-3 py-1 text-sm rounded-md transition-colors ${
                              page === current
                                ? "bg-primary text-primary-foreground font-medium"
                                : "bg-card hover:bg-accent border border-border"
                            }`}
                          >
                            {page}
                          </button>
                        );
                      } else if (page === current - 2 || page === current + 2) {
                        return (
                          <span key={page} className="text-muted-foreground">
                            ...
                          </span>
                        );
                      }
                      return null;
                    })}
                  </div>

                  <button
                    onClick={() =>
                      updateFilter(
                        "page",
                        String(data.pagination.currentPage + 1),
                      )
                    }
                    disabled={
                      data.pagination.currentPage === data.pagination.totalPages
                    }
                    className="p-2 border border-border rounded-md bg-card hover:bg-accent disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  >
                    <ChevronRight size={16} />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Modals */}
        {/* <AddPackageModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} /> */}
        <EditPackageModal
          isEditModalOpen={isEditModalOpen}
          setIsEditModalOpen={setIsEditModalOpen}
          package={selectedPackage}
        />
        <DeleteConfirmModal
          isDeleteModalOpen={isDeleteModalOpen}
          setIsDeleteModalOpen={setIsDeleteModalOpen}
          package={selectedPackage}
        />
        <ViewPackageModal
          isViewModalOpen={isViewModalOpen}
          setIsViewModalOpen={setIsViewModalOpen}
          package={selectedPackage}
        />
      </div>
    </Layout>
  );
};

export default PackageManagement;
